<template>
  <a
    class="break-words underline"
    href="mailto:kunne@universitetsforlaget.no"
  >Ta kontakt med oss på kunne@universitetsforlaget.no</a>
</template>
